import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {NgClass} from '@angular/common';
import {AuthService} from '../../../core/auth/auth.service';

@Component({
  selector: 'app-logout-button',
  templateUrl: './logout-button.component.html',
  styleUrls: ['./logout-button.component.scss'],
  imports: [NgClass],

})
export class LogoutButtonComponent {
  @Input() variant: 'grey' | 'transparent' = 'grey';
  @Input() navigateTo?: string;

  constructor(
    private router: Router,
    private authService: AuthService
  ) {
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login'], {
      replaceUrl: true,
      queryParamsHandling: 'preserve',
    });
  }
}
